import Marionette from 'backbone.marionette';
import watchedBillsCategoryLayoutTmpl from '../templates/category_show_layout.tpl';
export default Marionette.LayoutView.extend({
  template: watchedBillsCategoryLayoutTmpl,
  regions: {
    headlineRegion: "#headline-region",
    billListRegion: "#bill-list-region"
  }
});